import styled from 'styled-components';
import { Row as AntdRow, Col as AntdCol } from 'antd';

export const Row = styled(AntdRow)`
  margin-top: 0.5rem;
`;

export const GreetingBox = styled(AntdCol)<{ isReminder: boolean }>`
  margin-left: 0.5rem;
  ${(props) =>
    props.isReminder &&
    `
      display: flex;
      gap: 8px;
      flex-direction: column;
    `}
`;
